var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.6553 8.81462V7.39359C10.6559 6.43316 10.3242 5.50062 9.71398 4.74678C9.10375 3.99294 8.25063 3.46187 7.29257 3.23944C7.29986 3.21188 7.30554 3.18394 7.30957 3.15575V1.28946C7.30957 1.08008 7.22428 0.879281 7.07246 0.731228C6.92065 0.583175 6.71474 0.5 6.50004 0.5C6.28534 0.5 6.07944 0.583175 5.92762 0.731228C5.77581 0.879281 5.69052 1.08008 5.69052 1.28946V3.15575C5.69454 3.18394 5.70022 3.21188 5.70752 3.23944C4.74946 3.46187 3.89633 3.99294 3.2861 4.74678C2.67587 5.50062 2.34421 6.43316 2.34476 7.39359V8.81462C2.34476 10.6983 0.833374 11.1688 0.833374 12.1106C0.833374 12.5788 0.833374 13.0525 1.2689 13.0525H11.7312C12.1667 13.0525 12.1667 12.5788 12.1667 12.1106C12.1667 11.1688 10.6553 10.6983 10.6553 8.81462Z",
    fill: "#8E8E8E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.92818 13.8419C4.14293 14.3338 4.50124 14.7532 4.95852 15.048C5.4158 15.3428 5.95187 15.5 6.50004 15.5C7.04821 15.5 7.58428 15.3428 8.04157 15.048C8.49885 14.7532 8.85715 14.3338 9.0719 13.8419H3.92818Z",
    fill: "#8E8E8E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellGrey);
export default __webpack_public_path__ + "static/media/bell_grey.89bf5d092de9764f76e4eed4a63d91c3.svg";
export { ForwardRef as ReactComponent };